export default __webpack_public_path__ + "static/media/BizTwo.56ef3033.png";